import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { HeaderComponent } from '@app/core/layout/header/header.component';
import { FooterComponent } from '@app/core/layout/footer/footer.component';
import { ShellComponent } from '@app/core/layout/shell/shell.component';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { AuthenticationGuard } from '@app/core/guards/authentication.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpTokenInterceptor } from '@app/core/interceptors/http.token.interceptor';
import { JwtService } from '@app/core/services/jwt.service';
import { UserService } from '@app/core/services/user.service';
import { ApiService } from '@app/core/services/api.service';
import { OAuthService } from '@app/core/services/oauth.service';
import { NgbModule } from '../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { FileService } from '@app/core/services/file.service';
import { CommonService } from '@app/core/services/common.service';
import { IdentityService } from '@app/core/services/identity.service';
import { ProfileService } from '@app/core/services/profile.service';
import { ReportService } from '@app/core/services/report.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule
  ],
  declarations: [
    HeaderComponent, 
    FooterComponent, 
    ShellComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    AuthenticationService,
    AuthenticationGuard,
    JwtService,
    UserService,
    FileService,
    ApiService,
    OAuthService,
    CommonService,
    IdentityService,
    ProfileService,
    ReportService
  ]
})
export class CoreModule { }
